import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-user-risk-information',
  templateUrl: './card-user-risk-information.component.html',
  styleUrls: ['./card-user-risk-information.component.scss']
})
export class CardUserRiskInformationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
